var Backbone, FAQBreadCrumbView, FAQMainView, FaqBreadcrumbTemplate,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

FaqBreadcrumbTemplate = require('../../breadcrumb.html.mustache');

Backbone = require('backbone');

Backbone.$ = $;

FAQMainView = require('./main');

FAQBreadCrumbView = (function(superClass) {
  extend(FAQBreadCrumbView, superClass);

  function FAQBreadCrumbView() {
    return FAQBreadCrumbView.__super__.constructor.apply(this, arguments);
  }

  FAQBreadCrumbView.prototype.initialize = function() {
    this.I18nScope = 'modules.faq';
    this.template = FaqBreadcrumbTemplate;
    this.container = $('#breadcrumb');
    return this.invalidate();
  };

  FAQBreadCrumbView.prototype.invalidate = function() {
    this.container.empty();
    return this.searchHistory = new Array(this.constructFaqMainbreadCrumb());
  };

  FAQBreadCrumbView.prototype.addCrumbs = function(levelResponse) {
    if ((levelResponse != null) && (levelResponse.searchId != null) && (levelResponse.text != null)) {
      this.searchHistory.push(levelResponse);
      return true;
    } else {
      return false;
    }
  };

  FAQBreadCrumbView.prototype.render = function() {
    return this.toHtml();
  };

  FAQBreadCrumbView.prototype.toHtml = function() {
    this.$el.html(toHtml(this.template, this.toHash(this.searchHistory), this.I18nScope));
    return this.container.html(this.el);
  };

  FAQBreadCrumbView.prototype.toHash = function(history) {
    var breadCrumbs;
    if ((history != null ? history.length : void 0) > 0) {
      breadCrumbs = history;
      breadCrumbs[breadCrumbs.length - 1].isCurrentLevel = true;
      return {
        levels: breadCrumbs,
        show: (breadCrumbs != null ? breadCrumbs.length : void 0) > 1 ? true : false
      };
    } else {
      return null;
    }
  };

  FAQBreadCrumbView.prototype.constructFaqMainbreadCrumb = function() {
    var hash;
    hash = {
      searchId: FAQMainView.VIEWNAME,
      text: I18n.t('js.modules.faq.faq_main')
    };
    return hash;
  };

  return FAQBreadCrumbView;

})(Backbone.View);

module.exports = FAQBreadCrumbView;

//# sourceMappingURL=data:application/json;base64,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
